import {Button} from '@/components/ui/button/Button'
import {Dialog, DialogBody, DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledEventFormDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing * 4.5}px ${spacing * 6}px;
    `
)

export const StyledEventFormDialog = styled(Dialog)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
`

export const StyledEventFormDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)

export const StyledAgendaEditEventButton = styled(Button)(
    ({theme: {palette, spacing}}) => css`
        justify-content: flex-start;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 0;
        &:hover:not(:disabled) {
            background-color: ${palette.neutral['100']};
        }
    `
)
